<template>
  <div class="studio-product-checkout-paypal-confirm container">
    <div class="row">
      <div class="col-12">
        <!--        <h1 class="my-4">{{ $t('PRODUCTS.TITLE.CHECKOUT') }}</h1>-->
      </div>
    </div>
    <div
      class="row d-flex justify-content-center my-5"
      v-if="!waitingForPurchase && product"
    >
      <div class="col-12 content">
        <ProductPostPurchaseModal
          class="justify-content-start"
          :product="product"
          :studioURL="studioURL"
          :hideHeader="true"
          :eventId="eventId"
        />
      </div>
    </div>
    <div class="row d-flex justify-content-center my-5" v-else>
      <div class="col-12 text-center">
        <h2>{{ $t('PRODUCTS.TEXT.WAITING_FOR_PAYMENT_CONFIRMATION') }}</h2>
        <HMSpinner class="mt-4" />
        <div class="py-5"></div>
        <div class="py-5"></div>
        <div class="py-5"></div>
        <div class="py-5"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductPostPurchaseModal from '@/web/components/products/ProductPostPurchaseModal';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import Cookies from 'js-cookie';
import ProductUpsellModal from '../../components/products/ProductUpsellModal';

export default {
  name: 'StudioProductCheckoutPayPalConfirm',
  components: {
    ProductPostPurchaseModal,
  },
  computed: {
    ...mapGetters({
      product: 'product/product',
      currency: 'studio/currency',
      isLoggedIn: 'user/isLoggedIn',
      user: 'user/user',
      studio: 'studio/currentStudio',
    }),
    productId() {
      return this.$route.params.product_id;
    },
    studioURL() {
      return getStudioURL(this.$route);
    },
  },
  data() {
    return {
      purchasedProduct: null,
      waitingForPurchase: true,
      eventId: null,
    };
  },
  methods: {
    async loadProductStatus() {
      this.purchasedProduct = await this.$store.dispatch(
        'product/getProductForPurchase',
        {
          studioURL: this.studioURL,
          productId: this.productId,
        }
      );
      if (!this.purchasedProduct.purchased) {
        this.waitingForPurchase = true;
        setTimeout(() => {
          this.loadProductStatus();
        }, 5000);
      } else {
        this.$store.dispatch('user/studentPunches');
        this.waitingForPurchase = false;
        if (this.purchasedProduct.upsell_available) {
          if (
            this.purchasedProduct.upsell_product &&
            this.purchasedProduct.upsell_seconds_remaining > 0
          ) {
            this.$modal.show(
              ProductUpsellModal,
              {
                product: this.purchasedProduct,
                studioURL: this.studioURL,
              },
              {
                clickToClose: false,
              }
            );
          }
        }
      }
    },
  },
  async mounted() {
    this.eventId = Cookies.get('checkouteventid');
    this.$store.dispatch('product/getProductDetail', {
      studioURL: this.studioURL,
      productId: this.productId,
    });
    this.loadProductStatus();
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.content {
  max-width: 600px;
}
</style>
